import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTarget = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1323 2.96882V2.96878C7.68566 2.96878 5.92889 3.7807 4.77789 5.06394C3.62973 6.34398 3.08105 8.10562 3.08105 10.0464C3.08105 11.9669 3.62481 13.7187 4.77121 14.9939C5.91977 16.2716 7.67677 17.0836 10.1343 17.0836C12.5919 17.0836 14.3489 16.2666 15.4975 14.9863C16.644 13.7084 17.1875 11.9565 17.1875 10.0464C17.1875 8.1057 16.6437 6.34422 15.4979 5.06426C14.3491 3.78102 12.592 2.96878 10.1343 2.96878V2.96882L10.133 2.96878L10.1323 2.96882ZM10.1323 3.76878H10.1343C12.3137 3.76878 13.8831 4.4599 14.9018 5.59782C15.9233 6.73894 16.3875 8.31626 16.3875 10.0464C16.3875 11.7474 15.923 13.3141 14.9021 14.4521C13.8834 15.5876 12.3139 16.2836 10.1343 16.2836C7.95454 16.2836 6.38494 15.5924 5.36618 14.4591C4.34526 13.3235 3.88105 11.7567 3.88105 10.0464C3.88105 8.31634 4.34994 6.73918 5.37341 5.5981C6.39402 4.46026 7.96281 3.76878 10.1323 3.76878Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1288 5.62494C8.58707 5.62494 7.48179 6.1421 6.75611 6.95078C6.03319 7.7563 5.68359 8.86354 5.68359 10.0849C5.68359 11.2939 6.02975 12.3952 6.75135 13.198C7.47511 14.0031 8.58007 14.5205 10.1288 14.5205C11.6776 14.5205 12.7828 14.0001 13.5067 13.1932C14.2284 12.3888 14.5744 11.2873 14.5744 10.0849C14.5744 8.86366 14.2281 7.75658 13.507 6.95114C12.783 6.14246 11.6778 5.62494 10.1288 5.62494ZM10.1288 6.42494C11.3995 6.42494 12.317 6.82138 12.9109 7.48474C13.5077 8.15134 13.7744 9.07422 13.7744 10.0849C13.7744 11.0782 13.5074 11.9945 12.9112 12.659C12.3172 13.321 11.3996 13.7205 10.1288 13.7205C8.85787 13.7205 7.94027 13.3239 7.34631 12.6632C6.75019 12 6.48359 11.0836 6.48359 10.0849C6.48359 9.07434 6.75335 8.15158 7.35147 7.4851C7.94679 6.82174 8.86407 6.42494 10.1288 6.42494Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.1301 8.35938C9.54651 8.35938 9.13187 8.56454 8.85719 8.8707C8.58535 9.1737 8.44727 9.58782 8.44727 10.047C8.44727 10.5023 8.58423 10.9148 8.85595 11.217C9.12983 11.5217 9.54415 11.727 10.1301 11.727C10.716 11.727 11.1306 11.5207 11.4046 11.2153C11.6765 10.9124 11.8133 10.4998 11.8133 10.047C11.8133 9.5879 11.6763 9.17394 11.4051 8.87102C11.131 8.5649 10.7165 8.35938 10.1301 8.35938ZM10.1301 9.15938C10.4382 9.15938 10.665 9.24377 10.8091 9.40461C10.9559 9.56865 11.0133 9.79838 11.0133 10.047C11.0133 10.2906 10.9555 10.518 10.8092 10.681C10.6651 10.8416 10.4382 10.927 10.1301 10.927C9.82187 10.927 9.59499 10.8425 9.45091 10.6822C9.30467 10.5195 9.24727 10.2921 9.24727 10.047C9.24727 9.7985 9.30555 9.56889 9.45267 9.40493C9.59695 9.24413 9.82351 9.15938 10.1301 9.15938Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.1589 15.2344L3.9209 19.7796L4.69274 19.9898L5.93074 15.4446L5.1589 15.2344Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.1367 3.38918L11.2834 6.10352e-05H9.02044L8.33496 3.26834L9.11792 3.43258L9.67004 0.800061H10.6599L11.361 3.58454L12.1367 3.38918Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2656 19.7796L15.0604 15.2344L14.2871 15.4394L15.4923 19.9846L16.2656 19.7796Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.6096 19.5735V16.7187H9.80957V19.5735H10.6096Z"
		})
	]
});
const ForwardRef = forwardRef(SvgTarget);
export default ForwardRef;
